import * as React from 'react';
import { useState, useEffect } from 'react';
import MonthlyRevenue from './MonthlyRevenue';
import NbNewOrders from './NbNewOrders';
import NewInstalls from './NewInstalls';
import ItemsInCart from './ItemsInCart';
import { useNavigate } from 'react-router-dom';
import apiUrl from '../config';
import Box from '@mui/material/Box';

//import genericDataProvider from '../utils/dataProvider';
//import addUploadFeature from '../utils/addUploadCapabilities';

//const dataProvider = addUploadFeature(genericDataProvider);

const styles = {
    flex: { display: 'flex' },
    flexColumn: { display: 'flex', flexDirection: 'row' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '3em', marginBottom: '2em' },
};

export const Dashboard = () => {
    const [nbNewOrders, setNbNewOrders] = useState(0);
    const [revenue, setRevenue] = useState(0);
    const [installs, setInstalls] = useState(0);
    const [itemsInCart, setItemsInCart] = useState(0);
    
    useEffect(() => {
        var url = `${apiUrl}/dashboard`;
        const options = { 
            headers : new Headers({
                Accept: 'application/json'
            }),
        };
    
        const token = localStorage.getItem('token');

        // Authorization token.
        if(token) { 
          options.headers.set('Authorization', token); 
        }

        fetch(url, options).then(response => {
            if (response.status === 401 || response.status === 403) {

                localStorage.removeItem('username');
                localStorage.removeItem('token');
                localStorage.removeItem('role');
                localStorage.removeItem('avatar');
    
                useNavigate('/login');

                return Promise.reject('Failed authorization.');
            } else {
                return response.json();
            }
        }).then(json => {
            var data = json.data;

            var revenue = data.revenue;

            setItemsInCart(data.items_in_cart);
            setInstalls(data.installs);
            setNbNewOrders(data.new_orders);
            setRevenue(revenue.toLocaleString(undefined, {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }));

        });
    }, []);
        
    return <Box mt={2}>
                <div style={styles.flex} sx={{ top: '1rem' }} mt={2}>
                    <MonthlyRevenue value={revenue} />
                    <NbNewOrders value={nbNewOrders} />
                    <NewInstalls value={installs} />
                    <ItemsInCart value={itemsInCart} />
                </div>
            </Box>
};